/**
 * @generated SignedSource<<a996ff27a549a933b7e8bb87b1fc0530>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type furtherReadingWidgetArticle$data = {
  readonly moreOnThisArticles: ReadonlyArray<{
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"articleWidgetContent">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "furtherReadingWidgetArticle";
};
export type furtherReadingWidgetArticle$key = {
  readonly " $data"?: furtherReadingWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"furtherReadingWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "furtherReadingWidgetArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "moreOnThisArticles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "articleWidgetContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "5948a44e3b4e1ad86423c256e205bcbd";

export default node;
